import { useAuth } from "@/components/Auth";
import { Navigate, Outlet } from "react-router";


const ProtectedRoute: React.FC = () => {
    const { currentUser } = useAuth();
    return currentUser ? (
        <Outlet />
    ) : (
        <Navigate to="/" />
    )
}

export default ProtectedRoute;